import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  help: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  text: {
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    marginBottom: theme.spacing(1.125),
  },
  steps: {
    margin: `0 0 ${theme.spacing(3)}`,
    paddingLeft: theme.spacing(2.5),
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    marginTop: theme.spacing(2.75),
    '& li': {
      marginBottom: theme.spacing(0.5),
    },
  },
  usage: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  cmdRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.textBackground.light,
    boxSizing: 'border-box',
    width: theme.spacing(90),
  },
  cmd: {
    flex: 1,
    minWidth: 0,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    wordBreak: 'break-all',
  },
  cmdMake: {
    color: theme.palette.warning.main,
  },
  cmdVars: {
    color: '#048297',
  },
  copyBtnWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    flexShrink: 0,
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.dividerV2.main,
  },
  copyBtn: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  copyIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(2),
    color: theme.palette.shadows.dark,
  },
  copied: {
    color: theme.palette.success.main,
  },
  titleIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    color: theme.palette.labraIcon.main,
  },
}))
